export default __webpack_public_path__ + "static/media/Table.a0310357.svg";